import React from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "src/componets/Buttons";
import { setEditId, SmsPackageInterface } from "src/store/callrecorder/smsPackagesSlice";
import { EntityId } from "@reduxjs/toolkit";
import usePermissions from "src/hooks/usePermissions";
import { formattedDate } from "src/helpers/DateHelpers";
import Pagination from "src/componets/Pagination";

import { Space, Tag } from "antd";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.callrecorder.smsPackages.ids);
  const packages = useAppSelector(state => state.callrecorder.smsPackages.entities);
  const count = useAppSelector(state => state.callrecorder.smsPackages.count);
  const { write_callrecorder } = usePermissions();
  const data  = ids ? ids.map(id => packages[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const renderActiveLabel = (active: boolean) => {
    if (active) {
      return <Tag color="success">active</Tag>
    } else {
      return <Tag color="default">inactive</Tag>
    }
  }

  const columns: ColumnsType<SmsPackageInterface> = [
    {
      key: 'name',
      title: 'Name',
      render: (_, { name }) => <small>{name}</small>,
      width: 120,
      ellipsis: true
    },

    {
      key: 'sms_count',
      title: 'SMS Count',
      render: (_, { sms_count }) => <small>{sms_count}</small>,
      width: 100
    },

    {
      key: 'discount',
      title: 'Discount',
      render: (_, { discount }) => <small>{`${discount}%`}</small>,
      width: 100
    },

    {
      key: 'active',
      title: 'Status',
      render: (_, { active }) => renderActiveLabel(active),
      width: 100
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },

    ...(write_callrecorder ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id }: SmsPackageInterface) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 100
    }] : []),
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
        search_keys={['name']}
        sort_keys={['sms_count', 'discount', 'created_at', 'updated_at']}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
